import React from "react";

export const RENDER_MODE_EDIT = "edit";
export const RENDER_MODE_THUMB = "thumb";
export const RENDER_MODE_PREVIEW = "preview";

const RenderContext = React.createContext(null);

export default RenderContext;
